<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">考核规则配置</div>

      <el-form-item label="自动考核">
        <el-radio-group v-model="form.level_status">
          <el-radio :label="1">开启考核</el-radio>
          <el-radio :label="0">关闭考核</el-radio>
        </el-radio-group>
        <div style="color:#ff6f06">注：根据设置规则进行考核</div>
      </el-form-item>
      <el-form-item label="考核指标（支持多选）">
        <el-checkbox-group v-model="selectedArr" @change="arrchange">
          <el-checkbox border v-for="item in form.leave_message" :key="item.id" :label="item.id" :checked="item.selected == '1'" @change="updateSelected(item)">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
        <div style="color:#ff6f06">注：根据设置规则进行考核</div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import Technician from "@/api/technician.js";
export default {
  data() {
    return {
      form: {
        level_status: "",
        leave_message: []
      },
      selectedArr: [],
      /*form表单数据*/
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    updateSelected(item) {
      // 将选中状态为 true 的元素的 selected 属性值改为 '1'，将选中状态为 false 的元素的 selected 属性值改为 '2'
      item.selected = item.selected === "1" ? "2" : "1";
      console.log("===========", this.form);
    },
    arrchange(e) {
      console.log("===========", e);
      this.selectedArr = e;
    },
    getData() {
      let self = this;
      Technician.Levelwaiter({}, true)
        .then(data => {
          self.form = data.data;
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = {};
      params.level_status = self.form.level_status;
      params.level_message = self.selectedArr;
      // let params = this.form;
      Technician.Levelwaiteredit(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/assess/index.vue